import React from "react";
import HandleItems from "../Handle/HandleItems";

function Items() {
  return <HandleItems />;
}

export default Items;
